module.exports = __webpack_public_path__ + "static/img/RAPU-Z_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPU-Z_1.png
// module id = u2Ts
// module chunks = 0